// Pure validation for the onboarding Step 1 account form. Returns a Dutch error
// string for the first problem found, or null when the form may be submitted.
//
// Order matters: required fields first, then password match, then the
// terms/privacy consent — so a blank form complains about the fields before the
// checkbox. The consent rule is here (not a silent disabled button) so the user
// always sees why submit was blocked.
const validateStep1Account = ({ forname, email, password, passwordRepeat, acceptedTerms }) => {
    if (!forname || !email || !password) {
        return 'Vul je voornaam, e-mailadres en wachtwoord in.'
    }

    if (password !== passwordRepeat) {
        return 'De wachtwoorden komen niet overeen.'
    }

    if (!acceptedTerms) {
        return 'Je moet akkoord gaan met de algemene voorwaarden en het privacybeleid.'
    }

    return null
}

export default validateStep1Account
